var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v("Symbol's occurrences")]),_c('multiplier',{attrs:{"disabled":_vm.disabled,"min":1,"max":100,"step":1},model:{value:(_vm.model.rules.occurrences),callback:function ($$v) {_vm.$set(_vm.model.rules, "occurrences", $$v)},expression:"model.rules.occurrences"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }